var _clipPath, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageWhyFeature3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 42,
    viewBox: "0 0 42 42",
    width: 42,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h42v42h-42z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.69777 5.78152c-.43407.0038-.84929.17791-1.15623.48486-.30695.30694-.48106.72216-.48485 1.15622v2.46191h3.20781v-2.46191c.0064-.21101-.0292-.4212-.1047-.61834-.0756-.19714-.1895-.3773-.3353-.53s-.3205-.27489-.5139-.35948-.40175-.12989-.61283-.13326z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.2395 37.4866h-36.47959c-.36272.0008-.72204-.07-1.0573-.2084-.33527-.1385-.63988-.3418-.896341-.5983-.256457-.2565-.459707-.5612-.598073-.8965s-.20912168-.6946-.20820242-1.0573v-1.8647h42.00000642v1.8647c.0009.3628-.0699.7221-.2083 1.0575-.1384.3353-.3417.64-.5982.8965s-.5612.4598-.8965.5982c-.3354.1384-.6947.2092-1.0575.2083z",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.181 11.4512h-5.1481l-3.5333-.4512h-3l-3 .4512h-2.5-2-3.5-2.2351-5.74409c-.47282.0065-.92446.1972-1.25883.5316s-.52508.786-.53154 1.2588v18.4254h34.16696v-18.4254c.0051-.2303-.0353-.4593-.1188-.674-.0835-.2146-.2085-.4107-.3679-.577s-.35-.2995-.561-.3921c-.2109-.0925-.438-.1426-.6683-.1473z",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.3784 4.5134h-16.8598l.4479.29859c.4543.3041.8275.71438 1.0875 1.1953.2599.48092.3987 1.01797.4043 1.56461v19.7714h17.3814v-20.36799c-.0056-.65111-.2667-1.27396-.727-1.73443-.4604-.46047-1.0832-.72172-1.7343-.72748zm-.5228 10.9665h-11.7118v-1.2687h11.7124zm0-2.8349h-11.7118v-1.1938h11.7124zm0-2.7599h-11.7118v-1.19436h11.7124z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageWhyFeature3);
export default __webpack_public_path__ + "static/media/imageWhyFeature3.c83264dd6c027e3b871e50e538699c2a.svg";
export { ForwardRef as ReactComponent };